<vb-title [title]="webcastInfo.title"></vb-title>

<webcast-info-view [webcast]="webcastInfo">

	@if (status.processing) {
		<div [ngClass]="styles.loadingContainer">
			<vb-loading-spinner [msg]="'Loading' | translate" [size]="'large'">
			</vb-loading-spinner>
		</div>
	}
	@else if(status.completed) {
		<div [ngClass]="styles.formBody">
			<span class="fw-bold">{{ 'Event_PreRegistration_Success' | translate }}</span>
			@if (webcastInfo.emailToPreRegistrants) {
				{{ 'Event_PreRegistration_EmailSent' | translate }}
			}
			<div class="fw-bold mt-2 mb-2">{{ 'Event_RegistrationDetails' | translate }}</div>
			<div class="mb-2">{{formData.name}}</div>
			<div class="mb-2">{{formData.email}}</div>
		</div>
	}
	@else if(status.active) {
		<form name="form" #form="ngForm" [ngClass]="styles.form" (submit)="submit()">

			@if(!viewContext.AnonymousPwd) {

				<div [ngClass]="styles.formBody">
					<h2>{{ (isOnPrem ? 'Event_Guests' : 'Register') | translate }}</h2>

					<div class="system-msg error-msg" *ngIf="error" [ngSwitch]="error">
						<ng-container *ngSwitchCase="'AttendeeRemoved'">
							<span class="glyphicons circle_exclamation_mark"></span>
							{{ 'Event_AttendeeRemovedFromWebcast' | translate }}
						</ng-container>
						<ng-container *ngSwitchCase="'GuestAlreadyRegistered'">
							<span class="glyphicons circle_exclamation_mark"></span>
							{{ 'Event_Registration_EmailAlreadyRegistered_Error' | translate }}
						</ng-container>
						<ng-container *ngSwitchCase="'Unknown'">
							<span class="glyphicons remove_2"></span>
							{{ 'Event_Registration_SignInError' | translate }}
							<span [hidden]="!webcastInfo.isPasswordRequired">{{ 'Event_Registration_SignInError_VerifyPassword' | translate }}</span>
						</ng-container>
					</div>

					<vb-ui-form-group>
						<label #uiLabel for="registrationName">{{'Event_Registration_Name' | translate}}</label>

						<input type="text" class="form-control input-with-icon" name="name" id="registrationName" #name="ngModel" vbRequired autocomplete="name" [(ngModel)]="formData.name" uiControl vbUiTextInput trim="blur"/>
						<div *ngIf="name.touched && name.invalid" role="alert" class="margin-bottom-10" vbUiErrorMessage uiValidation>
							@if (name.errors.required) {
								{{ 'ThisFieldIsRequired' | translate }}
							}
						</div>
					</vb-ui-form-group>

					<vb-ui-form-group>
						<label #uiLabel for="email">{{'Event_Registration_Email' | translate}}</label>

						<input type="text" id="email" class="form-control input-with-icon" name="email" #email="ngModel" vbRequired autocomplete="email" [(ngModel)]="formData.email" vbEmail uiControl vbUiTextInput trim="blur"/>
						<div *ngIf="email.touched && email.invalid" role="alert" class="margin-bottom-10" vbUiErrorMessage uiValidation>
							@if (email.errors.required) {
								{{ 'ThisFieldIsRequired' | translate }}
							} @else if (email.errors.vbEmail) {
								{{ 'Event_Registration_Email_Invalid' | translate }}
							}
						</div>
					</vb-ui-form-group>

					<vb-ui-form-group *ngIf="webcastInfo.isPasswordRequired">
						<label #uiLabel for="password">{{'Event_Registration_Password' | translate}}</label>

						<input type="password" class="form-control input-with-icon" name="password" id="password" #password="ngModel" vbRequired autocomplete="new-password" [(ngModel)]="formData.password" uiControl vbUiTextInput trim="blur"/>

						<div *ngIf="password.touched && password.invalid" role="alert" class="margin-bottom-10" vbUiErrorMessage uiValidation>
							@if (password.errors.required) {
								{{ 'ThisFieldIsRequired' | translate }}
							}
						</div>
					</vb-ui-form-group>
					<ng-container *ngFor="let field of webcastInfo.registrationFields; index as index">
						<ng-container [ngSwitch]="field.fieldType">
							<vb-ui-form-group *ngSwitchCase="'Text'">
								<label #uiLabel [for]="'customField' + index">{{field.name}}</label>
								<input type="text" class="form-control" [name]="'customField' + index" [id]="'customField' + index" #customTxt="ngModel" [(ngModel)]="field.value" [vbRequired]="field.required" uiControl vbUiTextInput trim="blur"/>
									<div *ngIf="showFieldError(customTxt)" class="margin-bottom-10" role="alert" vbUiErrorMessage uiValidation>
										{{ 'ThisFieldIsRequired' | translate }}
									</div>
							</vb-ui-form-group>
							<vb-ui-form-group *ngSwitchCase="'Select'">
								<label #uiLabel [for]="'customField' + index">{{field.name}}</label>
								<select #customSelect="ngModel" class="form-select" [name]="'customField' + index" [id]="'customField' + index" [(ngModel)]="field.value" [required]="field.required" [attr.aria-label]="field.name" uiControl>
									@if(!field.required) {
										<option [ngValue]="''"></option>
									}
									<option *ngFor="let option of field.options" [ngValue]="option">
										{{option}}
									</option>
								</select>
								<div *ngIf="showFieldError(customSelect)" class="margin-bottom-10" role="alert" vbUiErrorMessage uiValidation>
									{{ 'ThisFieldIsRequired' | translate }}
								</div>
							</vb-ui-form-group>
						</ng-container>
					</ng-container>
				</div>

				<div [ngClass]="styles.formBodyLower">
					<vb-ui-checkbox #gdpr="ngModel" name="gdprConsent" [(ngModel)]="formData.gdprConsent">
						@if (webcastInfo.isCustomConsentEnabled) {
							<auto-link class="util-white-space-pre-wrap" [text]="webcastInfo.consentVerbiage"></auto-link>
						}
						@else {
							<div class="util-white-space-pre-wrap">{{'Event_Registration_GdprConsent' | translate }}</div>
						}
					</vb-ui-checkbox>

					<div [ngClass]="styles.toolbar">
						<span>{{'Event_Registration_ExistingUser' | translate}}</span>

						<a [href]="loginUrl" class="text-decoration-underline">
							{{'SignIn' | translate}}
						</a>
						<button type="submit" [disabled]="form.invalid" vbBtnPrimary>
							{{ (isOnPrem ? 'Event_Registration_SignInAsGuest' : 'Register') | translate }}
						</button>
					</div>
				</div>

			}
			@else {
				<div [ngClass]="styles.formBody">
					<div class="system-msg error-msg" *ngIf="error" [ngSwitch]="error">
						<ng-container *ngSwitchCase="'Unknown'">
							<span class="glyphicons remove_2"></span>
							{{ 'Event_Registration_SignInError' | translate }}
							<span [hidden]="!webcastInfo.isPasswordRequired">{{ 'Event_Registration_SignInError_VerifyPassword' | translate }}</span>
						</ng-container>
					</div>
					<vb-ui-form-group *ngIf="webcastInfo.isPasswordRequired">

						<label #uiLabel for="webcastPassword">{{'Event_Registration_Password' | translate}}</label>

						<input type="password" id="webcastPassword" class="form-control input-with-icon" name="password" #password="ngModel" vbRequired autocomplete="new-password" [(ngModel)]="formData.password" uiControl vbUiTextInput trim="blur"/>

						<div *ngIf="password.touched && password.invalid" class="margin-bottom-10" role="alert" vbUiErrorMessage uiValidation>
							@if (password.errors.required) {
								{{ 'ThisFieldIsRequired' | translate }}
							}
						</div>
					</vb-ui-form-group>
				</div>
				<div class="d-flex justify-content-end mt-2">
					<button type="submit" [disabled]="form.invalid" vbBtnPrimary>
						{{ 'Event_JoinWebcast' | translate }}
					</button>
				</div>
			}
		</form>
	}
</webcast-info-view>
